import { makeStyles } from '@material-ui/core/styles'
import UpComingImage from 'src/assets/PolicyDetails_Images/UpComingImage.svg'
import ClaimProcessImage from 'src/assets/PolicyDetails_Images/ClaimProcessImage.svg'
import InsuranceCeoImage from 'src/assets/PolicyDetails_Images/insuranceCeoImage.svg'
import {
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import DedicatedImage from 'src/assets/PolicyDetails_Images/DedicatedImage.svg'
import BidFarewell from 'src/assets/PolicyDetails_Images/BidFarewell.svg'
import AdminTeams from 'src/assets/PolicyDetails_Images/AdminTeams.svg'
import call from 'src/assets/PolicyDetails_Images/call.svg'
import WhatsApp from 'src/assets/PolicyDetails_Images/WhatsApp.svg'
import React, { useState } from 'react'
import {
  GET_ACCOUNT_MANAGER_DETAILS,
  GET_INSURANCE_TYPES,
  getClaimAssure,
} from 'src/services/individualService'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import { useQuery } from '@apollo/client'
import LoadingModal from 'src/components/common/LoadingModal'
import { getFullName, getInsuranceTypesList } from 'src/utils/commonMethods'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import { useDispatch } from 'react-redux'
import {
  CANNOT_RAISE_REQUEST,
  ERROR_ENCOUNTERED_WHILE_SUBMIT,
  ISVALIDPHONE,
  PHONE,
  REQUEST_CAPTURED,
} from 'src/utils/constants/Individual'
import { FETCH_USER_NOTIFICATION } from 'src/utils/constants/AppConstants'

const ClaimAssureGuard = ({ clientId, emailId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    insuranceType: '',
    name: '',
    phone: '',
    isPhoneValid: true,
    emailId,
    clientId,
  })

  const phoneRegex = /^\d{10}$/
  const [loading, setLoading] = useState(false)
  const handleInputChange = (event) => {
    const { name, value } = event?.target
    const isPhoneValid = name === PHONE ? phoneRegex?.test(value) : true
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      isPhoneValid,
    }))
  }

  const handleSubmit = async (event) => {
    event?.preventDefault()
    if (formData?.emailId) {
      await initiateClaim()
    } else {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.WARNING,
          message: CANNOT_RAISE_REQUEST,
        })
      )
    }
  }

  const initiateClaim = async () => {
    setLoading(true)
    delete formData[ISVALIDPHONE]
    const response = await getClaimAssure(formData)
    try {
      setLoading(false)
      if (response?.res?.status !== 200) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: FETCH_USER_NOTIFICATION?.TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }

      if (response?.res?.data?.success) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.SUCCESS,
            message: REQUEST_CAPTURED,
          })
        )

        setFormData({
          insuranceType: '',
          name: '',
          phone: '',
          isPhoneValid: true,
          emailId,
          clientId,
        })
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ENCOUNTERED_WHILE_SUBMIT,
        })
      )
    }
  }

  const {
    loading: insuranceTypesAggregateLoading,
    error: insuranceTypesAggregateError,
    data,
  } = useQuery(GET_INSURANCE_TYPES(), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: accountManagerDetailsLoading,
    error: accountManagerDetailsError,
    data: accountManagerDetailsData,
  } = useQuery(GET_ACCOUNT_MANAGER_DETAILS(clientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  if (insuranceTypesAggregateLoading || accountManagerDetailsLoading)
    return (
      <div>
        <CircularProgress />
      </div>
    )

  if (insuranceTypesAggregateError || accountManagerDetailsError)
    return (
      <>
        <GraphQlErrors
          error={insuranceTypesAggregateError}
          routeValue={'back'}
        />
      </>
    )

  const insuranceTypesList = getInsuranceTypesList(
    data?.getMasterData?.response?.[0]?.data
  )

  const accountManagerDetails =
    accountManagerDetailsData?.getAccountManagerDetails?.accountManagerDetails
  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.claimContainer}>
          <div className={classes.contactContainer}>
            <div className={classes.contactContent}>
              <form onSubmit={handleSubmit} id='claimForm'>
                <div className={classes.contactHeadingContent}>
                  <div className={classes.contactHeading}>Initiate Claim</div>
                  <div className={classes.contactTextContent}>
                    <span className={classes.contactText}>
                      Type of Insurance
                    </span>
                    <FormControl fullWidth>
                      <Select
                        labelId='typeOfInsurance'
                        id='insuranceType'
                        name='insuranceType'
                        placeholder='Insurance Type'
                        displayEmpty
                        defaultValue=''
                        value={formData?.insuranceType}
                        onChange={(event) => handleInputChange(event)}
                        className={classes.insuranceTypeField}
                      >
                        <MenuItem
                          value={''}
                          className={'default-menu-item'}
                          disabled
                        >
                          Insurance Type
                        </MenuItem>
                        {insuranceTypesList?.map((subType) => (
                          <MenuItem key={subType?.id} value={subType}>
                            {subType}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.contactTextContent}>
                    <span className={classes.contactText}>Name</span>
                    <br></br>
                    <TextField
                      id='name'
                      name='name'
                      type='text'
                      placeholder='Name Here'
                      value={formData?.name}
                      onChange={(event) => handleInputChange(event)}
                      required
                      className={classes.nameField}
                    />
                  </div>
                  <div className={classes.contactTextContent}>
                    <span className={classes.contactText}>Phone Number</span>
                    <br></br>
                    <TextField
                      id='phone'
                      name='phone'
                      type='number'
                      placeholder='+91'
                      value={formData?.phone}
                      onChange={(event) => {
                        event.target.value = Math.max(
                          0,
                          parseInt(event?.target?.value)
                        )
                          ?.toString()
                          ?.slice(0, 10)
                        handleInputChange(event)
                      }}
                      required
                      error={!formData?.isPhoneValid}
                      helperText={
                        !formData?.isPhoneValid ? 'Invalid phone number' : ''
                      }
                      className={classes.nameField}
                    />
                  </div>
                </div>
                <div className={classes.submit}>
                  <Button
                    type='submit'
                    id='submitButton'
                    className={classes.submitText}
                  >
                    Submit
                  </Button>
                </div>
              </form>
            </div>
          </div>
          <div className={classes.accountManagerContainer}>
            <div className={classes.dedicatedContainer}>
              <div className={classes.dedicateContent}>
                <span>Your Dedicated</span>
              </div>
              <div>
                <img
                  src={DedicatedImage}
                  alt='dedicatedImage'
                  className={classes.dedicatedImage}
                />
              </div>
            </div>
            <div>
              <div className={classes.claimText}>
                <span>Claim AssureGuard</span>
              </div>
              <div>
                {accountManagerDetails !== null ? (
                  <div>
                    <div className={classes.claimContent}>
                      <span className={classes.textName}>
                        {getFullName([
                          accountManagerDetails?.firstName,
                          accountManagerDetails?.lastName,
                        ])}
                      </span>
                      <br></br>
                      <span className={classes.textSubName}>
                        Insurance Expert
                      </span>
                    </div>
                    <div className={classes.claimContent}>
                      <span className={classes.text}>
                        {accountManagerDetails?.phoneNumber}
                      </span>
                      <br></br>
                      <span className={classes.text}>
                        {accountManagerDetails?.mail}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div>
                    <span className={classes.textName}>
                      No Account Manager Assigned
                    </span>
                  </div>
                )}
                <div className={classes.contactCallContainer}>
                  <div className={classes.callContent}>
                    <div>
                      <img src={call} alt='call' />
                    </div>
                    <div>
                      <span className={classes.callText}>Call</span>
                    </div>
                  </div>
                  <div className={classes.callContent}>
                    <div>
                      <img src={WhatsApp} alt='whatsApp' />
                    </div>
                    <div>
                      <span className={classes.callText}>Chat</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.container}>
          <div className={classes.bidFarewellContainer}>
            <div>
              <img src={BidFarewell} alt='bidFarewell' />
            </div>
            <div>
              <span>
                Trovity simplifies the process of claiming insurance.
                <b>Bid farewell to claim-related worries!</b>
              </span>
            </div>
          </div>
          <div className={classes.bidFarewellContainer}>
            <div>
              <img src={AdminTeams} alt='adminTeams' />
            </div>
            <div>
              <span>
                <b> Ease the workload of your Employees, HR, and Admin teams</b>{' '}
                by entrusting all insurance paperwork and claim follow-ups to
                Trovity.
              </span>
            </div>
          </div>
        </div>
        <div className={classes.insuranceContainer}>
          <div className={classes.trovityContent}>
            <span>
              At Trovity, whether it&apos;s employee benefit policies or asset
              policies, we&apos;re masters of all.
            </span>
          </div>
          <img
            src={InsuranceCeoImage}
            alt='insuranceCeoImage'
            className={classes.insuranceCeoImage}
          />
          <div className={classes.insuranceText}>
            <span>
              Always reach out to{' '}
              <span className={classes.insuranceSubText}>
                Trovity&apos;s Relationship Manager
              </span>
            </span>
            <br></br>
            <span className={classes.insuranceDescription}>
              for comprehensive information and assistance regarding claims.
            </span>
          </div>
          <div className={classes.insuranceCeoText}>
            <span>We&apos;re your INSURANCE CEO!</span>
          </div>
        </div>
        <div className={classes.upcomingContainer}>
          <div className={classes.upcomingHeading}>
            <span>Upcoming Features</span>
          </div>
          <img
            src={UpComingImage}
            alt='upcomingImage'
            className={classes.upcomingImage}
          />
        </div>
        <div className={classes.claimProcessContainer}>
          <div className={classes.claimHeading}>
            <span>Claim Process</span>
          </div>
          <img
            src={ClaimProcessImage}
            alt='claimProcessImage'
            className={classes.claimImage}
          />
        </div>
      </div>
    </>
  )
}
export default ClaimAssureGuard
const useStyles = makeStyles({
  claimContainer: {
    display: 'flex',
    padding: '20px 50px',
    gap: '30px',
    justifyContent: 'center',
    flexWrap: 'wrap-reverse',
  },
  submit: {
    border: '1px solid #EF669B',
    borderRadius: '20px',
    width: '85px',
    marginTop: '20px',
    marginLeft: '45px',
  },
  nameField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
      fontStyle: 'italic',
      fontSize: '12px',
    },
  },
  submitText: {
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '15px',
    color: '#B92250 !important',
    padding: '10px',
  },
  contactTextContent: {
    width: '190px',
    paddingBottom: '10px',
  },
  contactHeadingContent: {
    textAlign: 'start',
  },
  contactContainer: {
    textAlign: 'center',
  },
  insuranceTypeField: {
    '&  .MuiSelect-select': {
      height: '0.7rem !important',
      minHeight: 'unset !important',
      fontSize: '12px',
    },
  },
  contactText: {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: '400',
  },
  contactHeading: {
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '21px',
    color: '#2F2F2F',
    padding: '20px 0px',
  },
  contactContent: {
    // padding: '20px',
    textAlign: 'center',
  },
  dedicatedImage: {
    maxWidth: '249px',
    width: '100%',
  },
  dedicatedContainer: {
    display: 'flex',
    // '@media only screen and (max-width:500px)': {
    //   flexDirection:'column'
    // },
  },
  dedicateContent: {
    padding: '21px 0px',
    marginRight: '-125px',
  },
  claimText: {
    fontSize: '28px',
    fontWeight: '500',
    color: '#EF669B',
    lineHeight: '36px',
    marginLeft: '-30px',
    padding: '15px 0',
  },
  textName: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23px',
    textTransform: 'capitalize',
  },
  textSubName: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '18px',
  },
  text: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16px',
  },
  callContent: {
    border: '1px solid #EF669B',
    borderRadius: '20px',
    display: 'flex',
    gap: '8px',
    padding: '5px 10px',
  },
  contactCallContainer: {
    display: 'flex',
    gap: '5px',
    padding: '10px 0px',
  },
  callText: {
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '15px',
    color: '#B92250',
  },
  claimContent: {
    paddingBottom: '20px',
  },
  upcomingHeading: {
    fontSize: '28px',
    lineHeight: '32px',
    fontWeight: '400',
    color: '#3EB3D3',
    textAlign: 'center',
    padding: '20px 0px',
  },
  upcomingImage: {
    width: '100%',
    maxWidth: '850px',
    padding: '10px 10px 0px 10px',
  },
  upcomingContainer: {
    borderBottom: '4px solid #4DC3E3',
    textAlign: 'center',
  },
  claimProcessContainer: {
    textAlign: 'center',
    padding: '20px 0px',
  },
  claimHeading: {
    fontSize: '28px',
    fontWeight: '400',
    lineHeight: '32px',
    padding: '30px 0px 5px 0px',
  },
  claimImage: {
    width: '100%',
    maxWidth: '830px',
    padding: '10px',
  },
  insuranceContainer: {
    textAlign: 'center',
    padding: '10px 0px',
    borderBottom: '1px solid #4DC3E3',
  },
  trovityContent: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '18px',
    padding: '30px',
  },
  insuranceCeoImage: {
    maxWidth: '425px',
    width: '100%',
  },
  insuranceText: {
    fontSize: '23px',
    lineHeight: '26px',
    fontWeight: '400',
    padding: '15px 0px',
  },
  insuranceSubText: {
    fontWeight: '700',
  },
  insuranceDescription: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '18px',
  },
  insuranceCeoText: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#EF669B',
    lineHeight: '21px',
    fontStyle: 'italic',
    padding: '15px 0px',
  },
  bidFarewellContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    border: '1px solid #D7D7D7',
    borderRadius: '10px',
    padding: '20px',
    width: '50%',
    '@media only screen and (max-width:768px)': {
      width: 'unset',
    },
  },
  container: {
    display: 'flex',
    gap: '15px',
    padding: '20px 0px',
    '@media only screen and (max-width:768px)': {
      flexDirection: 'column',
    },
  },
  accountManagerContainer: {
    display: 'flex',
    gap: '30px',
    '@media only screen and (max-width:548px)': {
      flexDirection: 'column',
    },
  },
})
